export default __webpack_public_path__ + "media/images/react_icons/gastronomy-f79358574cd4e897dee41ab623da3933.svg";